import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import withMessages from 'component-utilities/intl';
import styles from './Login.scss';

function component({ href, getMessage }) {
    return (
        <a
            href={href}
            title={getMessage('components.login.sso.bcc')}
        >
            <span className={styles['sso-barracuda']} />
        </a>
    );
}

component.propTypes = {
    href: PropTypes.string.isRequired,
    getMessage: PropTypes.func.isRequired,
};

const SingleSignOnBarracudaButton = withMessages(component);
SingleSignOnBarracudaButton.displayName = displayName('Login/SingleSignOnBarracudaButton');

export default SingleSignOnBarracudaButton;
